/** Remember which shop storefront a customer belongs to across logout / session expiry. */
export const CUSTOMER_SHOP_SLUG_STORAGE_KEY = 'oms-customer-shop-slug'

export function rememberCustomerShopSlug(slug: string | null | undefined): void {
  const normalized = String(slug || '').trim()
  if (!normalized) return
  try {
    sessionStorage.setItem(CUSTOMER_SHOP_SLUG_STORAGE_KEY, normalized)
  } catch {
    /* ignore quota / private mode */
  }
}

export function readRememberedCustomerShopSlug(): string | null {
  try {
    const slug = sessionStorage.getItem(CUSTOMER_SHOP_SLUG_STORAGE_KEY)?.trim()
    return slug || null
  } catch {
    return null
  }
}

/** Prefer shop home after sign-out; fall back to shop-scoped login. */
export function customerPostLogoutPath(): string {
  const slug = readRememberedCustomerShopSlug()
  if (slug) return `/shop/${encodeURIComponent(slug)}`
  return '/auth/customer/login'
}

export function customerLoginPathWithShop(opts?: { redirect?: string }): string {
  const slug = readRememberedCustomerShopSlug()
  if (!slug) return '/auth/customer/login'
  const params = new URLSearchParams()
  params.set('shop', slug)
  if (opts?.redirect) params.set('redirect', opts.redirect)
  return `/auth/customer/login?${params.toString()}`
}
